import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtgFooterComponent } from './atg-footer.component';
import { RouterModule } from '@angular/router';
import { GenericLinkModule, NavigationModule } from '@spartacus/storefront';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AtgContactUsDialogModule } from '../atg-contact-us-dialog/atg-contact-us-dialog.module';

@NgModule({
  declarations: [AtgFooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    NavigationModule,
    GenericLinkModule,
    I18nModule,
    NgbModalModule,
    AtgContactUsDialogModule,
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: () => import('./atg-footer.component').then((c) => c.AtgFooterComponent),
        },
      },
    } as CmsConfig),
  ],
  exports: [AtgFooterComponent],
})
export class AtgFooterModule { }
